module.exports = "<div>\r\n  <h1>404: page missing</h1>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Projects/dod/companyintroduction/src/app/no-content/no-content.component.html
// module id = ../../../../../src/app/no-content/no-content.component.html
// module chunks = main